import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import TheHouse from "@/pages/TheHouse";
import Manifesto from "@/pages/Manifesto";
import Methodology from "@/pages/Methodology";
import ExpertMinds from "@/pages/ExpertMinds";
import ExpertProfile from "@/pages/ExpertProfile";
import Journal from "@/pages/Journal";
import JournalEntry from "@/pages/JournalEntry";
import PrivateInquiry from "@/pages/PrivateInquiry";
import Services from "@/pages/Services";
import ServicesDetail from "@/pages/ServicesDetail";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/the-house" element={<TheHouse />} />
              <Route path="/manifesto" element={<Manifesto />} />
              <Route path="/methodology" element={<Methodology />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:service" element={<ServicesDetail />} />
              <Route path="/expert-minds" element={<ExpertMinds />} />
              <Route path="/expert-minds/:slug" element={<ExpertProfile />} />
              <Route path="/journal" element={<Journal />} />
              <Route path="/journal/:slug" element={<JournalEntry />} />
              <Route path="/private-inquiry" element={<PrivateInquiry />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
